<button (click)="logout()">Logout</button>